import {
  actualStateDisplayLabel,
  normalizeActualState,
} from "../../utils/shiftActualState";
import {
  formatDurationAfterBreak,
  formatShiftDateTime,
} from "../../utils/shiftListStatusDisplay";
import "./ShiftActualTimeSubmissionCell.css";

const ACTUAL_CHIP_COLORS = {
  as_scheduled: "#4ea45b",
  asscheduled: "#4ea45b",
  different: "#c9b030",
  no_show: "#8e77af",
  noshow: "#8e77af",
};

function resolveScheduleStart(shift) {
  return (
    shift?.startDateIso ||
    shift?.start_date ||
    shift?.startDate ||
    shift?.start_time ||
    null
  );
}

function resolveScheduleEnd(shift) {
  return (
    shift?.endDateIso ||
    shift?.end_date ||
    shift?.endDate ||
    shift?.end_time ||
    null
  );
}

export default function ShiftActualHistoryCell({ row, shift }) {
  const actualStateNorm = normalizeActualState(row?.actualState);
  const actualStateRaw = row?.actualState || "";

  const actualStart = row?.actualStartDate || null;
  const actualEnd = row?.actualEndDate || null;
  const actualBreak = row?.actualUnpaidBreakMinutes ?? 0;

  const scheduleStart = resolveScheduleStart(shift);
  const scheduleEnd = resolveScheduleEnd(shift);

  const showTimes =
    actualStateNorm === "as_scheduled" ||
    actualStateNorm === "asscheduled" ||
    actualStateNorm === "different";

  const displayStart =
    actualStart ||
    (actualStateNorm === "as_scheduled" || actualStateNorm === "asscheduled"
      ? scheduleStart
      : null);
  const displayEnd =
    actualEnd ||
    (actualStateNorm === "as_scheduled" || actualStateNorm === "asscheduled"
      ? scheduleEnd
      : null);
  const displayBreak =
    actualStateNorm === "as_scheduled" || actualStateNorm === "asscheduled"
      ? Number(shift?.unpaid_break ?? 0) > 0
        ? 30
        : 0
      : actualBreak;

  const chipColor =
    ACTUAL_CHIP_COLORS[actualStateNorm] || ACTUAL_CHIP_COLORS.as_scheduled;
  const chipLabel = actualStateDisplayLabel(actualStateRaw);

  if (actualStateNorm === "no_show" || actualStateNorm === "noshow") {
    return (
      <div className="shift-actual-cell">
        <div className="shift-actual-cell__chip-row">
          <span
            className="shift-actual-cell__chip"
            style={{ backgroundColor: chipColor }}
          >
            {chipLabel}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="shift-actual-cell">
      {showTimes && (displayStart || displayEnd) && (
        <div className="shift-actual-cell__times">
          <span className="text-foreground">
            {displayStart && displayEnd
              ? `${formatShiftDateTime(displayStart)} - ${formatShiftDateTime(displayEnd, false)}`
              : displayStart
                ? formatShiftDateTime(displayStart)
                : displayEnd
                  ? formatShiftDateTime(displayEnd, false)
                  : ""}
          </span>
          <span className="shift-actual-cell__duration">
            {formatDurationAfterBreak(
              displayStart || scheduleStart,
              displayEnd || scheduleEnd,
              displayBreak,
              { showZeroBreak: actualStateNorm === "different" },
            )}
          </span>
        </div>
      )}
      <div className="shift-actual-cell__chip-row">
        <span
          className="shift-actual-cell__chip"
          style={{ backgroundColor: chipColor }}
        >
          {chipLabel}
        </span>
      </div>
    </div>
  );
}
